import React,{ useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  hovPreview:{
     position: 'relative',
  },
  hovBlockImg:{
    display: 'none',
    position: 'absolute',
    zIndex: '2',
    left: '65px',
  },
  hovImg:{
    width: 'auto',
    height: '160px',
  },
}));

export default function ImageField ({ record, source, width }) {
  const [hoverPrev, sethoverPrev] = useState('none');
  const hoverPrevBlock = () => {
    sethoverPrev('block');
  }
  const hoverPrevHide = () => {
    sethoverPrev('none');
  }
  const classes = useStyles();
  if (record)
    return (
      <div className={classes.hovPreview} onMouseOver={hoverPrevBlock} onMouseOut={hoverPrevHide}>
        <span className={classes.hovBlockImg} style={{display:hoverPrev}} >
          <img className={classes.hovImg} src={record[source]} alt={record[source]} />
        </span>
        <a href={record[source]} target="_blank" rel="noopener noreferrer">
          <img src={record[source]} width={width} alt={record[source]} />
        </a>
      </div>
    );
  return null;
};
